import { ReactElement, SVGProps } from 'react'
export const SvgMastercard = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg width={48} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={48} height={32} rx={4} fill="#fff" />
    <g clipPath="url(#mastercard_svg__a)" fillRule="evenodd" clipRule="evenodd">
      <path d="M20.388 22.27h6.958V9.709h-6.958V22.27Z" fill="#FF5F00" />
      <path
        d="M20.83 15.989a7.987 7.987 0 0 1 3.037-6.281A7.896 7.896 0 0 0 18.952 8C14.56 8 11 11.577 11 15.989c0 4.411 3.56 7.988 7.952 7.988a7.896 7.896 0 0 0 4.915-1.708 7.988 7.988 0 0 1-3.038-6.28Z"
        fill="#EB001B"
      />
      <path
        d="M36.734 15.989c0 4.411-3.56 7.988-7.952 7.988a7.895 7.895 0 0 1-4.915-1.708 7.987 7.987 0 0 0 3.038-6.28 7.988 7.988 0 0 0-3.038-6.281A7.895 7.895 0 0 1 28.782 8c4.392 0 7.952 3.577 7.952 7.989Z"
        fill="#F79E1B"
      />
    </g>
    <defs>
      <clipPath id="mastercard_svg__a">
        <path fill="#fff" transform="translate(8 8)" d="M0 0h32v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
